import { render, staticRenderFns } from "./EditNameDescription.vue?vue&type=template&id=17a552d9&"
import script from "./EditNameDescription.vue?vue&type=script&lang=js&"
export * from "./EditNameDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a552d9')) {
      api.createRecord('17a552d9', component.options)
    } else {
      api.reload('17a552d9', component.options)
    }
    module.hot.accept("./EditNameDescription.vue?vue&type=template&id=17a552d9&", function () {
      api.rerender('17a552d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Editbox/EditNameDescription.vue"
export default component.exports